import {environment} from '../environments/environment';
import packageJson from '../../package.json';

export const CONFIG = {
  NOMBREAPP: 'PADRES',
  COOLDOWN_MS: 3 * 60 * 1000,
  VERSION: packageJson.version,
  SITE_KEY_V3: environment.siteKeyV3,
  OPTIONS_RECAPTCHA: {useEnterprise: true, autoHideBadge: true},
  URL_HELP: 'https://space.kilobytelab.com/babycloud/docs/1662203163238-890877-301688.pdf',
  firebase: environment.firebase,
  MESES_DE_GRACIA: 1  // Nª de meses que se consideran de gracia para un alumno de baja pueda acceder a las imágenes
}

export const IMAGES = {
  SINFOTOALUMNO: 'assets/img/globos.png',
  SINFOTOEDUCADORA: 'assets/img/educadora.png',
  SINIMAGEN: 'assets/img/noimage.png',
  AVATAR: 'assets/img/avatar.svg',
  VACACIONES: 'assets/img/vacaciones.png',
  ENFERMEDAD: 'assets/img/enfermedad.png',
  FESTIVO: 'assets/img/festivo.png',
  BIBE: 'assets/img/bibe.png',
  BIEN: 'assets/img/bien.png',
  REGULAR: 'assets/img/regular.png',
  MAL: 'assets/img/mal.png',
  NADA: 'assets/img/nada.png',
  SIESTA1: 'assets/img/siesta1.png',
  SIESTA2: 'assets/img/siesta2.png',
  NOLECTIVO: 'assets/img/nolectivo.png',
  SEPA: 'assets/img/sepa.svg',
  WC: 'assets/img/wc-alter.png',
  TRIMESTRES: [
    'assets/img/trimestre_1.svg',
    'assets/img/trimestre_2.svg',
    'assets/img/trimestre_3.svg'
  ]
}